const certificateSteps = {
  CHOOSE_ACTION: "chooseAction",
  SELECT_DEVICES: "selectDevices",
  REVOKE_CONFIRMATION: "revokeConfirmation",
  DOWNLOADING: "downloading"
};

export default certificateSteps;
